export enum DOCUMENT_TYPE {
  LOGISTIC_SERVICE_PO = 'logisticServicePo',
  ORDER_PO = 'orderPo'
}

type TDocumentType = DOCUMENT_TYPE.LOGISTIC_SERVICE_PO | DOCUMENT_TYPE.ORDER_PO;

interface IDataDocumentPurchaseOrder {
  documentType: TDocumentType;
  entityId: number | string;
}

export type { IDataDocumentPurchaseOrder, TDocumentType };
